<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->
    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">
        <el-divider content-position="left">备用金信息</el-divider>

        <el-form-item label="申请人" prop="applyUser">
          <el-input v-model="detail.applyUser" readonly></el-input>
        </el-form-item>

        <el-form-item label="申请类型" prop="applyUser">
          <el-radio-group v-model="detail.type" style="cursor: not-allowed;pointer-events:none">
            <el-radio :label="1">项目费用</el-radio>
            <el-radio :label="2">管理费用</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="detail.type === 1">
          <el-form-item label="申请项目" prop="projectName">
            <el-input v-model="detail.projectName" readonly></el-input>
          </el-form-item>
        </div>

        <el-form-item label="申请金额" prop="amount">
          <el-input v-model="detail.amount" maxlength="12" readonly>
            <template slot="append">{{ paymentUpperMap.applyMoney }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="申请用途" prop="remark">
          <el-input type="textarea" v-model="detail.remark" rows="5" maxlength="200" show-word-limit readonly>
          </el-input>
        </el-form-item>

        <!--    -->
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>


        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>
    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import ContractDialog from "@/components/item/common/ContractDialog.vue";
import {digitUppercase, IsPdf, minioServer} from "@/util";

export default {
  components: {ContractDialog, AuditList, Title, Setp},
  name: "PaymentDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '备用金申请详情',
        path: ''
      },
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes: [],
      allowAudit: false,
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        applyMoney: digitUppercase(this.detail.amount),
      }
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>


</style>




